export default __webpack_public_path__ + "static/media/FacebookClone2.c3f5843b.jpg";